module.exports = __webpack_public_path__ + "static/media/image-analise.a7854a88.png";